import { environment } from 'src/config/env/env'
import { createCall } from '@fubotv/api-client/lib'

function createApiCall() {
  const { env, api } = environment
  const context = { env, api }
  const call = createCall(context)

  return {
    call,
  }
}

export const { call } = createApiCall()
